module.exports = __webpack_public_path__ + "static/media/file-icon.57384017.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/file-icon.svg
// module id = 45
// module chunks = 0